import { render, staticRenderFns } from "./DocflowCheckouts.vue?vue&type=template&id=c06e7518&scoped=true&"
import script from "./DocflowCheckouts.vue?vue&type=script&lang=js&"
export * from "./DocflowCheckouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06e7518",
  null
  
)

export default component.exports